module.exports = __webpack_public_path__ + "static/media/avanzado.0a2a4636.svg";